import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { GenerateContentElement } from '../nodes/GenerateContentElement'

export function unwrapGeneratedContent({
  editor,
}: {
  editor: BufferEditor
}): void {
  editor.tf.unwrapNodes({
    at: [],
    match: (n) => GenerateContentElement.is(n),
  })

  editor.hasGeneratedContent = false
}
